import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden"]

  declare readonly hiddenTarget: HTMLInputElement
  declare readonly hasHiddenTarget: boolean

  connect() {
    this.updateHiddenField()
  }

  format(event: Event) {
    const input = event.target as HTMLInputElement
    let value = input.value.replace(/\D/g, "") // Remove non-digits

    // Auto-insert slash after month
    if (value.length >= 2) {
      value = value.slice(0, 2) + "/" + value.slice(2)
    }

    // Limit to 7 characters (MM/YYYY)
    value = value.slice(0, 7)

    input.value = value
    this.updateHiddenField()
  }

  validate(event: Event) {
    const input = event.target as HTMLInputElement
    const value = input.value

    // Check if the month/year is complete and valid
    if (value.length === 7) {
      const [monthStr, yearStr] = value.split("/")
      const month = parseInt(monthStr, 10)
      const year = parseInt(yearStr, 10)

      if (month < 1 || month > 12 || year < 1900 || year > 2100) {
        input.setCustomValidity("Date invalide")
        input.reportValidity()
      } else {
        input.setCustomValidity("")
      }
    }
  }

  private updateHiddenField() {
    if (!this.hasHiddenTarget) return

    const input = this.element.querySelector('input[type="text"]') as HTMLInputElement
    if (!input) return

    const value = input.value

    if (value.length === 7) {
      const [month, year] = value.split("/")
      // Convert to YYYY-MM-DD format (first day of month) for the database
      this.hiddenTarget.value = `${year}-${month}-01`
    } else if (value.length === 0) {
      this.hiddenTarget.value = ""
    }
  }
}
